import React from 'react';

const AttestationDomiciliationSalaire = ({
                                             nomComplet,
                                             nomEntreprise = "GO&DEV DELIVERY CENTER",
                                             adresseEntreprise = "Villa 4 Rue Arromane Secteur 9 Bloc G Hay riad Rabat",
                                             capital = "200.000,00 DH",
                                             banque = "",
                                             agence = "",
                                             numeroCompte = "",
                                             lieu = "RABAT",
                                             date = "",
                                         }) => {
    return (
        <div style={{ padding: '40px', fontFamily: 'Georgia, serif', lineHeight: '1.8', position: 'relative', minHeight: '100vh' }}>
            <div style={{ textAlign: 'center' }}>
                <h2 style={{ marginBottom: '0px' }}>{nomEntreprise}</h2>
                <div style={{ fontSize: '14px' }}>
                    <p>SOCIETE A RESPONSABILITE LIMITEE AU</p>
                    <p>CAPITAL DE {capital}</p>
                    <p>SIEGE SOCIAL: {adresseEntreprise}</p>
                </div>
                <hr />
                <h3 style={{ textDecoration: 'underline' }}>ATTESTATION DE DOMICILIATION DE SALAIRE</h3>
            </div>

            <p>
                Je soussigné, Monsieur <strong>Pascal Georges Eugene RELLIER</strong>, Gérant de la société<br />
                <strong>{`«${nomEntreprise}»`}</strong>, Société à responsabilité limitée, sise au <strong>{adresseEntreprise}</strong>.<br />
                Atteste par la présente que nous nous engageons à virer mensuellement et irrévocablement,
                le salaire intégral et toutes les indemnités de Monsieur <strong>{nomComplet}</strong> à son compte ouvert
                à la Banque <strong>{banque || "........"}</strong> agence <strong>{agence || "........"}</strong> sous le numéro :
            </p>

            <p style={{ textAlign: 'center' }}>
                <strong>{numeroCompte || ".............................................."}</strong>
            </p>

            <p>
                Cette domiciliation ne pourra être révoquée qu’avec l’accord préalable et express de votre Banque.
            </p>

            <p>
                Enfin, en cas de démission ou de licenciement de Monsieur <strong>{nomComplet}</strong>,
                le solde de tout compte de Monsieur lui sera viré sur son compte ci-dessus mentionné.
            </p>

            <p>
                Cette attestation est délivrée pour servir et valoir ce que de droit.
            </p>

            <p style={{ textAlign: 'right', marginBottom: '100px' }}>
                Fait à {lieu}, le {date || "……………"}
            </p>

            <hr />

            <div style={{ fontSize: '12px', textAlign: 'center', marginTop: '22px' }}>
                SARL au capital de {capital} -
                CNSS: 1054596 -
                <strong>Identifiant Fiscal</strong>: 26159497 -
                TP: 25502215 -
                RC: 179995 –
                <strong>ICE</strong> : 002125743000033
            </div>
        </div>
    );
};

export default AttestationDomiciliationSalaire;
